import { ActionReducerMap } from '@ngrx/store';
import * as fromProject from './projects';
import { ProjectState } from './projects';
import * as fromUser from './user';
import { UserState } from './user';
import * as fromResource from './resource';
import { ResourceMapState } from './resource';
import * as fromSite from './site';
import { SiteState } from './site';
import { LanguageState } from './language';
import * as fromLanguage from './language';
import { SettingsState } from '@app/core/store/reducers/settings';
import * as fromSettings from '@app/core/store/reducers/settings';
import { CommentsState } from '@app/core/store/reducers/comments';
import * as fromComments from './comments';
import { WorkOrderState } from '@app/core/store/reducers/work-order';
import * as fromWorkOrder from '@app/core/store/reducers/work-order';
import { DashboardState } from '@app/core/store/reducers/dashboard';
import * as fromDashboard from '@app/core/store/reducers/dashboard';
import * as fromDocuments from './documents/index';
import { DocumentsState } from './documents/index';
import * as fromWorkCenter from './work-center';
import { WorkCenterState } from './work-center';
import * as fromPdfMarkup from './pdf-markup';
import { PdfMarkupState } from './pdf-markup';

export interface State {
  resource: ResourceMapState;
  projects: ProjectState;
  user: UserState;
  sites: SiteState;
  langauage: LanguageState;
  settings: SettingsState;
  comments: CommentsState;
  workOrder: WorkOrderState;
  dashboard: DashboardState;
  documents: DocumentsState;
  workCenters: WorkCenterState;
  pdfMarkup: PdfMarkupState;
}

export const initialState: State = {
  resource: fromResource.initialState,
  projects: fromProject.initialState,
  user: fromUser.initialState,
  sites: fromSite.initialState,
  langauage: fromLanguage.initialState,
  settings: fromSettings.initialState,
  comments: fromComments.initialState,
  workOrder: fromWorkOrder.initialState,
  dashboard: fromDashboard.initialState,
  documents: fromDocuments.initialState,
  workCenters: fromWorkCenter.initialState,
  pdfMarkup: fromPdfMarkup.initialState,
};

export const reducers: ActionReducerMap<State> = {
  resource: fromResource.resourceReducer,
  projects: fromProject.projectReducer,
  user: fromUser.userReducer,
  sites: fromSite.siteReducer,
  langauage: fromLanguage.languageReducer,
  settings: fromSettings.settingsReducer,
  comments: fromComments.commentsReducer,
  workOrder: fromWorkOrder.workOrderReducer,
  dashboard: fromDashboard.dashboardReducer,
  documents: fromDocuments.documentsReducer,
  workCenters: fromWorkCenter.workCenterReducer,
  pdfMarkup: fromPdfMarkup.pdfMarkupReducer,
};
